import React from "react";
import { useTheme } from "@mui/styles";
import { Box, Typography, useMediaQuery, Divider } from "@mui/material";
import HomeDesktop02 from "../../img/HomeDesktop02.png";
import Steps from "./Steps";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    width: "100vw",
    paddingBottom: "4rem",
    background:
      "linear-gradient(184deg, rgba(242,242,242,1) 0%, rgba(255,255,255,1) 100%)",
    backgroundImage: {
      md: `url(${HomeDesktop02})`,
    },
    backgroundRepeat: "no-repeat",
    backgroundSize: { xs: "cover", md: "100vw 700px" },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: { sx: "2500px", md: "inherit" },
  },
  titleContainer: {
    mt: { xs: "70px", md: "90px" },
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
  },
  title: {
    color: theme.palette.red.main,
    fontWeight: "600",
    letterSpacing: { xs: "1.4px", md: "1.6px" },
    fontSize: { xs: "14px", md: "16px" },
  },
  subtitle: {
    maxWidth: { xs: "277px", md: "649px", lg: "834px" },
    textAlign: "center",
    fontFamily: theme.typography.montserrat.regular,
    fontSize: { xs: "35px", md: "55px", lg: "65px" },
    lineHeight: { xs: "43px", md: "62px", lg: "72px" },
    mt: "30px",
    color: theme.palette.blue.main,
  },
  span: { fontWeight: "bold" },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
  divider: { width: "80vw", display: { xs: "none", md: "inherit" } },
});

const ProgrammingPath = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery("(max-width:899px)");
  const { pathname } = useLocation();
  const { title, subtitle, steps } = useTranslation(
    pathname,
    "ProgrammingPath"
  );

  return (
    <Box sx={classes.container} id="programmingPath">
      <Divider sx={classes.divider} />
      <Box sx={classes.titleContainer}>
        {isMobile ? null : <div style={classes.line}></div>}
        <Typography sx={classes.title}>{title}</Typography>
      </Box>

      <Typography sx={classes.subtitle}>
        {subtitle[0]}
        <span style={classes.span}>{subtitle[1]}</span>
        {subtitle[2]}
        <span style={classes.span}>{subtitle[3]}</span>
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "center", md: "flex-end" },
          justifyContent: "center",
          flexDirection: { xs: "column", md: "row" },
          mt: { xs: "40px", md: "100px" },
        }}
      >
        {steps.map((step, index) => {
          const { img, title, subtitle, path } = step;
          return (
            <Steps
              img={img}
              title={title}
              subtitle={subtitle}
              path={path}
              key={title}
              index={index}
              innerRef={props.innerRef}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default ProgrammingPath;
